import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { STRING_CONSTANTS } from "../utils/constants/stringConstants";

import SignUp from "../pages/Signup/index";
import GetStarted from "../pages/GetStarted/GetStarted";
import Login from "../pages/SignIn";
import ForgotPassword from "../pages/forgotPassword";
import ResetPassword from "../pages/resetPassword";
import Dashboard from "../pages/Dashboard/dashboard";

// legal
import ReferralHandler from "../pages/ReferralHandler"; // Adjust the path as needed

import TermsAndConditionsPage from "../components/TermsAndPrivacy/TermsAndConditionsPage";
import Privacy from "../pages/legal/privacy";
import Onboarding from "../pages/Onboarding";
import OnboardingTutorial from "../pages/Dashboard/Settings/OnboardingTutorial";
import GuardianDocumentUpload from "../pages/GuardianDocumentUpload";
import EmployerProfileCompletion from "../pages/EmployerProfileCompletion/index";
import EmployeeProfileCompletion from "../pages/EmployeeProfileCompletion/index";
import EmployeeAdvancedProfile from "../pages/EmployeeAdvancedProfile/index";
import JobCreation from "../pages/Dashboard/Job Creation/index";
import Settings from "../pages/Dashboard/Settings/index";
import Modules from "../pages/Dashboard/Modules/index";
import Chat from "../pages/Dashboard/Chat/index";

import ARDashboard from "../pages/AR/ARDashboard";
import ARSettings from "../pages/AR/ARSettings";
import ARTodo from "../pages/AR/ARTodo";
import ARAffiliate from "../pages/AR/ARAffiliate";
import ARAffiliateSetting from "../pages/AR/ARAffiliateSetting";
import ARAffiliateDemoAccounts from "../pages/AR/ARAffiliateDemoAccounts";
import ARView from "../pages/AR/ARView";

import CBALogin from "../pages/CBALogin";
import CBAForgotPassword from "../pages/CBAForgotPassword";
import CBAPrivacy from "../pages/CBA/CBAPrivacy";
import CBATermsAndConditionsPage from "../pages/CBA/CBATermsAndConditionsPage";
import CBAARDashboard from "../pages/CBA/CBAARDashboard";
import CBAARSettings from "../pages/CBA/CBAARSettings";
import CBAARView from "../pages/CBA/CBAARView";
import CBASignup from "../pages/CBA/CBASignup";

import CBAAccountsSection from "../pages/CBA/CBAAccountsSection";
import AdminLogin from '../pages/AdminLogin/AdminLogin';


import WhitelabelSettings from "../pages/Whitelabel/WhitelabelSettings";

import MarketingAudioVideo from "../pages/Marketing/AudioVideo";
import MarketingCampaign from "../pages/Marketing/Campaign";
import BlogManagement from "../pages/Marketing/BlogManagement";

import NotificationScreen from "../pages/Dashboard/Notifications/index";
import { actionCreators, State } from "../store";
import { bindActionCreators } from "redux";
import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";
import SuperUserLoginGate from "./SuperUserLoginGate";
import { getSuperUserTokenFromUrl } from "../utils/superUserLogin";
import { useDispatch, useSelector } from "react-redux";
import { cookieService } from "../_services";
import { api } from "../middleware/api";
import { END_POINTS } from "../utils/constants/endPoints";
import ToastHeader from "../components/toastHeader";
import { Data } from "../_services/collections";
import ARAffSignup from "../pages/Signup/ARAffSignup";
import ARAffiliateSignup from "../pages/Signup/ARAffiliateSignup";
import InterviewSimulatorSignup from "../pages/Signup/InterviewSimulatorSignup";
import InterviewDashboard from "../pages/InterviewSimulator/InterviewDashboard";
import InterviewJobs from "../pages/InterviewSimulator/InterviewJobs";
import InterviewJobDetail from "../pages/InterviewSimulator/InterviewJobDetail";
import InterviewStart from "../pages/InterviewSimulator/InterviewStart";
import InterviewPublicStart from "../pages/InterviewSimulator/InterviewPublicStart";
import InterviewCandidates from "../pages/InterviewSimulator/InterviewCandidates";
import InterviewResults from "../pages/InterviewSimulator/InterviewResults";
import InterviewResultDetail from "../pages/InterviewSimulator/InterviewResultDetail";
import InterviewBilling from "../pages/InterviewSimulator/InterviewBilling";
import InterviewCompanyProfile from "../pages/InterviewSimulator/InterviewCompanyProfile";
import InterviewQuestionSets from "../pages/InterviewSimulator/InterviewQuestionSets";
import InterviewInvites from "../pages/InterviewSimulator/InterviewInvites";
import InterviewSetup from "../pages/InterviewSetup/InterviewSetup";
import LegalAssistSignup from "../pages/Signup/LegalAssistSignup";
import HRSimulatorSignup from "../pages/Signup/HRSimulatorSignup";
import AppSelector from "../pages/AppSelector/AppSelector";
import EmployeeSignup from "../pages/Signup/EmployeeSignup";
import AffiliateProgram from "../pages/LandingPages/AffiliateProgram";
import AIAccountsReceivable from "../pages/LandingPages/AIAccountsReceivable";
import AIAccountsReceivableReminder from "../pages/LandingPages/AIAccountsReceivableReminder";

import SocketClient from "../library/SocketClient";
import Verified from "../pages/Dashboard/verified/Verified";
import Failed from "../pages/Dashboard/verified/Failed";

import SubscriptionWeb from "../pages/SubscriptionWeb";
import CBAAccountsReceivable from "../pages/LandingPages/CBAAccountsReceivable"; // @TODO: this is really the homepage and should be renamed

import InterviewSimulatorPage from "../pages/InterviewSimulatorPages/InterviewSimulator/InterviewSimulatorPage";
import InterviewPreparationPage from "../pages/InterviewSimulatorPages/InterviewSimulator/InterviewPreparationPage";
import HRAssisstentPage from "../pages/InterviewSimulatorPages/HrSimulatorPages/HRAssisstentPage";
import HrAvatarMode from "../pages/InterviewSimulatorPages/HrSimulatorPages/HrAvatarMode";
import Results from "../pages/InterviewSimulatorPages/InterviewSimulator/Results";
import PitchingResults from "../pages/InterviewSimulatorPages/TrainerSimulatorPages/PitchingResults";

import InterviewModePage from "../pages/InterviewSimulatorPages/InterviewSimulator/InterviewModePage";
import TrainerPitchingPage from "../pages/InterviewSimulatorPages/TrainerSimulatorPages/TrainerPitchingPage";
import TrainerIntroPage from "../pages/InterviewSimulatorPages/TrainerSimulatorPages/TrainerIntroPage";
import TrainerModePage from "../pages/InterviewSimulatorPages/TrainerSimulatorPages/TrainerModePage";
import PitchingPage from "../pages/InterviewSimulatorPages/TrainerSimulatorPages/PitchingPage";
import { WhitelabelProvider, useWhitelabel } from "../context/WhitelabelContext"; // Adjust path if needed

// check the domain to see if it is cba
if (window.location.hostname === "cbatest.com" ||
    window.location.hostname === "cbansw.mploi.com" ||
    window.location.hostname === "app.revrabbit.ai" ||
    window.location.hostname === "whitelabel.mploi.com" ||
    window.location.hostname === "accessintell.mploi.com" ||
    window.location.hostname === "whitelabel2.mploi.com" ||
    window.location.hostname === "accounts.wadvisory.com.au" ||
    window.location.hostname === "amaka.mploi.com"
) {
  console.log("WL MODE")
  window.whitelabel = true;
} else {
  console.log("STANDARD MODE", window.location.hostname);
}

// The old dark marketing pages are retired: mploi.com (Framer) is the public site now.
const ToMploiSite = () => {
  window.location.replace("https://mploi.com");
  return null;
};
// Logged-out visitors to the bare domain go straight to the (new look) sign-in page.
const ToSignIn = () => <Redirect to={STRING_CONSTANTS.navigationString.login} />;
// A fresh visit to /signup used to show the old "hire or work?" chooser; send it to the
// product picker instead. In-flow steps arrive with router state and still render SignUp.
const SignUpOrProductPicker = (props) =>
  props.location?.state ? <SignUp {...props} /> : <Redirect to={STRING_CONSTANTS.navigationString.signupAgents} />;

const AllRoutes = () => {
  const dispatch = useDispatch();
  const state = useSelector((state: State) => state);
  const { setUnreadNotificationCount, setReferralCode } = bindActionCreators(
    actionCreators,
    dispatch
  );
  const userTypeCookieval = cookieService.getCookie(
    STRING_CONSTANTS.cookieStrings.user
  );
  const [isUserLoggedIn, setUserLoggedIn] = useState(false);
  const regDeviceToken = () => {
    api
      .post("device-token/", {
        deviceType: "WEB",
        user: `${
          (cookieService.getCookie(STRING_CONSTANTS.cookieStrings.user) as Data)
            .user.id
        }`,
        token: `${cookieService.getCookie("fcm")}`,
      })
      .then
      // (res) => console.log(res)
      ()
      .catch
      // (e) => console.log(e)
      ();
  };

  useEffect(() => {
    if (userTypeCookieval?.user?.id) {
      setTimeout(() => {
        setUserLoggedIn(true);
      }, 2000);
    } else {
      setTimeout(() => {
        setUserLoggedIn(false);
      }, 2000);
    }
  }, [userTypeCookieval?.user?.id]);

  useEffect(() => {
    const urlString = window?.location.href;

    let paramString = urlString?.split("?")?.[1];
    let params_arr = paramString?.split("&");
    let keyArr = [];
    let valueArr = [];
    let uriMap = new Map();
    const user = cookieService.getCookie(STRING_CONSTANTS.cookieStrings.user);
    const token = cookieService.getCookie(STRING_CONSTANTS.cookieStrings.token);
    for (let i = 0; i < params_arr?.length; i++) {
      let pair = params_arr?.[i]?.split("=");
      keyArr.push(pair?.[0]);
      valueArr.push(pair?.[1]);
      uriMap.set(pair[0], pair[1]);
    }
    if (uriMap?.has("uidb64") && uriMap?.has("token")) {
      api
        .post(
          `${END_POINTS.login}?uidb64=${uriMap.get(
            "uidb64"
          )}&token=${uriMap.get("token")}`,
          null
        )
        .then((res: any) => {
          let response = res?.data?.user?.token?.access;
          cookieService.saveCookie(
            STRING_CONSTANTS.cookieStrings.user,
            res.data
          );
          cookieService.saveCookie(
            STRING_CONSTANTS.cookieStrings.token,
            response
          );
          setUnreadNotificationCount(res?.data?.user?.unreadNotificationCount);
        })
        .then(() => {
          window.location.replace(STRING_CONSTANTS.navigationString.index);
          if (cookieService.getCookie("fcm")) {
            regDeviceToken();
          }
        })
        .catch(function (error) {
          //debugger
          ToastHeader(error);
        });
    } else if (uriMap?.has("referral_code")) {
      setReferralCode(uriMap.get("referral_code"));
    } else if (
      uriMap?.has("advance_profile") &&
      uriMap?.has("user_id") &&
      user?.user?.type === STRING_CONSTANTS.userType.employee
    ) {
      if (user?.user && token && user?.user?.id == uriMap?.get("user_id")) {
        if (user?.isAdvanceProfileCompleted) {
          window.location.href = `${STRING_CONSTANTS.navigationString.advanced_profile}?source=notification`;
        } else {
          window.location.href = `${STRING_CONSTANTS.navigationString.advanced_profile}`;
        }
      }
    }
  }, [window?.location?.href]);

  useEffect(() => {
    if (cookieService.getCookie("unreadCount")) {
      setUnreadNotificationCount(cookieService.getCookie("unreadCount"));
    } else {
      if (cookieService.getCookie("token") && cookieService.getCookie("user")) {
        let cookie = cookieService.getCookie("user");
        setUnreadNotificationCount(cookie?.user?.unreadNotificationCount);
        cookieService.saveCookie(
          "unreadCount",
          cookie?.user?.unreadNotificationCount
        );
      }
    }
  }, []);

  // Super-admin console → "Open their dashboard": exchange the one-time token for the
  // customer's session before any PrivateRoute can redirect to /signin.
  const superUserToken = getSuperUserTokenFromUrl();
  if (superUserToken) {
    return <SuperUserLoginGate token={superUserToken} />;
  }

  return (
    <React.Fragment>
      {/* {cookieService.getCookie(STRING_CONSTANTS.cookieStrings.user)?.user?.type} */}
      <ToastContainer
        position="top-right"
        style={{ zIndex: 9999999 }}
        hideProgressBar
        //  autoClose={false}
      />
      <WhitelabelProvider>
      {isUserLoggedIn && <SocketClient />}
        <Router>
          <Switch>
            {!window.whitelabel ? (<Route exact path={"/employeesignup"} component={EmployeeSignup} />) : null}
            {!window.whitelabel ?<Route
              exact
              path={STRING_CONSTANTS.navigationString.signupAgents}
              component={GetStarted}
            /> : null}

            {!window.whitelabel ?<Route
              exact
              path={STRING_CONSTANTS.navigationString.signup}
              component={SignUpOrProductPicker}
            /> : null}

            {!window.whitelabel ?<Route
              exact
              path={STRING_CONSTANTS.navigationString.competition}
              component={ToMploiSite}
            /> : null}
            {!window.whitelabel ?<Route
              exact
              path={STRING_CONSTANTS.navigationString.contact}
              component={ToMploiSite}
            /> : null}
            {!window.whitelabel ?<Route
              exact
              path="/blog/:blogId"
              component={ToMploiSite}
            /> : null}
            {!window.whitelabel ? <PrivateRoute exact path="/interview-simulator/setup" component={InterviewSetup} /> : null}
            {!window.whitelabel ?<Route
              exact
              path={STRING_CONSTANTS.navigationString.interview_Simulator_Page}
              component={InterviewSimulatorPage}
            /> : null}
            {!window.whitelabel ?<Route
              exact
              path={STRING_CONSTANTS.navigationString.interview_Preparation_Page}
              component={InterviewPreparationPage}
            /> : null}
            {!window.whitelabel ? <Route
              exact
              path={STRING_CONSTANTS.navigationString.results}
              component={Results}
            /> : null}
            {!window.whitelabel ? <Route
              exact
              path={STRING_CONSTANTS.navigationString.interview_Mode_page}
              component={InterviewModePage}
            /> : null}
            {!window.whitelabel ?<Route
              exact
              path="/abudhabi"
              component={HRAssisstentPage}
            /> : null}
            {!window.whitelabel ?<Route
              exact
              path="/abudhabi/legal"
              component={HrAvatarMode}
            /> : null}
            {!window.whitelabel ?<Route
              exact
              path={STRING_CONSTANTS.navigationString.trainer_pitching_page}
              component={TrainerPitchingPage}
            /> : null}
            {!window.whitelabel ?<Route
              exact
              path={STRING_CONSTANTS.navigationString.trainer_intro_page}
              component={TrainerIntroPage}
            /> : null}
            {!window.whitelabel ?<Route
              exact
              path={STRING_CONSTANTS.navigationString.trainer_mode_page}
              component={TrainerModePage}
            /> : null}
            {!window.whitelabel ?<Route
              exact
              path={STRING_CONSTANTS.navigationString.pitching_page}
              component={PitchingPage}
            /> : null}
            {!window.whitelabel ?<Route
              exact
              path={STRING_CONSTANTS.navigationString.pitching_results}
              component={PitchingResults}
            /> : null}
            {!window.whitelabel ?<Route
              exact
              path={STRING_CONSTANTS.navigationString.guardianDocumentUpload}
              component={GuardianDocumentUpload}
            /> : null}
            {!window.whitelabel ?<PrivateRoute
              exact
              path={STRING_CONSTANTS.navigationString.dashboard.home}
              component={Dashboard}
            /> : null}
            {!window.whitelabel ?<PrivateRoute
              exact
              path={STRING_CONSTANTS.navigationString.onboardingTutorial}
              component={OnboardingTutorial}
            /> : null}
            {/* Affiliate self-signup: enabled on BOTH mploi and whitelabel domains */}
            <PrivateRoute
              exact
              path="/accounts/affiliate"
              component={ARAffiliateSignup}
            />
            {!window.whitelabel ? <PrivateRoute
              exact
              path={STRING_CONSTANTS.navigationString.employer_profile_completion}
              component={EmployerProfileCompletion}
            /> : null}
            {!window.whitelabel ? <PrivateRoute
              exact
              path={STRING_CONSTANTS.navigationString.employee_profile_completion}
              component={EmployeeProfileCompletion}
            /> : null}
            {!window.whitelabel ? <PrivateRoute
              exact
              path={STRING_CONSTANTS.navigationString.advanced_profile}
              component={EmployeeAdvancedProfile}
            /> : null}
            {!window.whitelabel ? <PrivateRoute
              exact
              path={STRING_CONSTANTS.navigationString.dashboard.settings}
              component={Settings}
            /> : null}
            {!window.whitelabel ? <PrivateRoute
              exact
              path={STRING_CONSTANTS.navigationString.dashboard.modules}
              component={Modules}
            /> : null}
            {!window.whitelabel ? <PrivateRoute
              exact
              path={STRING_CONSTANTS.navigationString.dashboard.job_creation}
              component={JobCreation}
            /> : null}
            {!window.whitelabel ? <PrivateRoute
              exact
              path={STRING_CONSTANTS.navigationString.dashboard.chat}
              component={Chat}
            /> : null}
            {!window.whitelabel ? <PrivateRoute
              exact
              path="/marketing/av"
              component={MarketingAudioVideo}
            /> : null}
            {!window.whitelabel ? <PrivateRoute
              exact
              path="/marketing/blog"
              component={BlogManagement}
            /> : null}
            {!window.whitelabel ? <PrivateRoute
              exact
              path="/marketing/campaign"
              component={MarketingCampaign}
            /> : null}
            {!window.whitelabel ? <PrivateRoute
              exact
              path={STRING_CONSTANTS.navigationString.dashboard.notifications}
              component={NotificationScreen}
            /> : null}
            {!window.whitelabel ? <PrivateRoute
              exact
              path={STRING_CONSTANTS.navigationString.dashboard.verified}
              component={Verified}
            /> : null}
            {!window.whitelabel ? <PrivateRoute
              exact
              path={STRING_CONSTANTS.navigationString.dashboard.failed}
              component={Failed}
            /> : null}
            {!window.whitelabel ? <Route
              exact
              path={STRING_CONSTANTS.navigationString.subscription_web}
              component={SubscriptionWeb}
            /> : null}
            {!window.whitelabel ? <PublicRoute
              exact
              path={STRING_CONSTANTS.navigationString.for_employees}
              component={ToMploiSite}
            /> : null}
            {!window.whitelabel ? <PublicRoute
              exact
              path={STRING_CONSTANTS.navigationString.for_employers}
              component={ToMploiSite}
            /> : null}
            {!window.whitelabel ? <PublicRoute
              exact
              path={STRING_CONSTANTS.navigationString.blogs}
              component={ToMploiSite}
            /> : null}
            {!window.whitelabel ? <PublicRoute
              exact
              path="/accounts"
              component={ToMploiSite}
            /> : null}
            {!window.whitelabel ? <PublicRoute
              exact
              path="/affiliates"
              component={AffiliateProgram}
            /> : null}
            {!window.whitelabel ? <PublicRoute
              exact
              path="/interview"
              component={ToMploiSite}
            /> : null}
            {!window.whitelabel ? <PublicRoute
              exact
              path="/accessintell"
              component={AIAccountsReceivable}
            /> : null}
            {!window.whitelabel ? <PublicRoute
              exact
              path="/accessintell/reminder"
              component={AIAccountsReceivableReminder}
            /> : null}
            {!window.whitelabel ? <PublicRoute
              exact
              path="/webinar"
              component={ToMploiSite}
            /> : null}
            {!window.whitelabel ? <PublicRoute
              exact
              path="/hr"
              component={ToMploiSite}
            /> : null}
            {!window.whitelabel ? <PublicRoute
              exact
              path="/security"
              component={ToMploiSite}
            /> : null}
            {!window.whitelabel ? <PublicRoute
              exact
              path="/trainer"
              component={ToMploiSite}
            /> : null}

            {!window.whitelabel ? <PublicRoute
              exact
              path="/legal"
              component={ToMploiSite}
            /> : null}


            {window.whitelabel ? (
              <PublicRoute
                exact
                path={STRING_CONSTANTS.navigationString.index}
                component={CBAAccountsReceivable}
              />
            ) : (
              <PublicRoute
                exact
                path={STRING_CONSTANTS.navigationString.index}
                component={ToSignIn}
              />
            )}
            
            <Route
              exact
              path={
                STRING_CONSTANTS.navigationString.resetpassword + "/:uidb/:token"
              }
              component={ResetPassword}
            />
            <Route 
              exact 
              path="/r/:referralCode" 
              component={ReferralHandler} 
            />

            {!window.whitelabel ? (<PublicRoute
              exact
              path={STRING_CONSTANTS.navigationString.login}
              component={Login}
            />) : (<PublicRoute
              exact
              path={STRING_CONSTANTS.navigationString.login}
              component={CBALogin}
            />)}

            {!window.whitelabel ? (<PublicRoute
              exact
              path={STRING_CONSTANTS.navigationString.forgotpassword}
              component={ForgotPassword}
            />) : (<PublicRoute
              exact
              path={STRING_CONSTANTS.navigationString.forgotpassword}
              component={CBAForgotPassword}
            />)}

            {!window.whitelabel ? (<Route
              exact
              path={STRING_CONSTANTS.navigationString.privacy}
              component={Privacy}
            />) : (<PublicRoute
              exact
              path={STRING_CONSTANTS.navigationString.privacy}
              component={CBAPrivacy}
            />)}

            {!window.whitelabel ? (<PublicRoute
              exact
              path={STRING_CONSTANTS.navigationString.terms}
              component={TermsAndConditionsPage}
            />) : (<PublicRoute
              exact
              path={STRING_CONSTANTS.navigationString.terms}
              component={CBATermsAndConditionsPage}
            />)}
            
            <PrivateRoute exact path="/app-selector" component={AppSelector} />

            {!window.whitelabel ? (<PrivateRoute
              exact
              path="/accounts/signup"
              component={ARAffSignup}
            />) : (<PrivateRoute
              exact
              path="/accounts/signup"
              component={CBASignup}
            />)}


            {!window.whitelabel ? (<Route exact path="/interview-simulator/job/:token" component={InterviewPublicStart} />) : null}
            {!window.whitelabel ? (<PrivateRoute
              exact
              path="/interview-simulator/signup"
              component={InterviewSimulatorSignup}
            />) : null}
            {!window.whitelabel ? (<PrivateRoute exact path="/interview-simulator/dashboard" component={InterviewDashboard} />) : null}
            {!window.whitelabel ? (<PrivateRoute exact path="/interview-simulator/profile" component={InterviewCompanyProfile} />) : null}
            {!window.whitelabel ? (<PrivateRoute exact path="/interview-simulator/questions" component={InterviewQuestionSets} />) : null}
            {!window.whitelabel ? (<PrivateRoute exact path="/interview-simulator/invites" component={InterviewInvites} />) : null}
            {!window.whitelabel ? (<PrivateRoute exact path="/interview-simulator/jobs" component={InterviewJobs} />) : null}
            {!window.whitelabel ? (<PrivateRoute exact path="/interview-simulator/jobs/:id/start" component={InterviewStart} />) : null}
            {!window.whitelabel ? (<PrivateRoute exact path="/interview-simulator/jobs/:id" component={InterviewJobDetail} />) : null}
            {!window.whitelabel ? (<PrivateRoute exact path="/interview-simulator/candidates" component={InterviewCandidates} />) : null}
            {!window.whitelabel ? (<PrivateRoute exact path="/interview-simulator/results" component={InterviewResults} />) : null}
            {!window.whitelabel ? (<PrivateRoute exact path="/interview-simulator/results/:id" component={InterviewResultDetail} />) : null}
            {!window.whitelabel ? (<PrivateRoute exact path="/interview-simulator/billing" component={InterviewBilling} />) : null}

            {!window.whitelabel ? (<PrivateRoute
              exact
              path="/legal-assist/signup"
              component={LegalAssistSignup}
            />) : null}

            {!window.whitelabel ? (<PrivateRoute
              exact
              path="/hr-simulator/signup"
              component={HRSimulatorSignup}
            />) : null}

            {!window.whitelabel ? (<PrivateRoute
              exact
              path="/hr/signup"
              component={HRSimulatorSignup}
            />) : null}

            {window.whitelabel ? (<PrivateRoute
              path="/accounts/whitelabel"
              component={CBAAccountsSection}
            />) : null}

            {!window.whitelabel ? (<PrivateRoute
              exact
              path="/ar"
              component={ARDashboard}
            />) : (<PrivateRoute
              exact
              path="/ar"
              component={CBAARDashboard}
            />)}


            {!window.whitelabel ? (<PrivateRoute
              exact
              path="/ar/settings/:organizationId"
              component={ARSettings}
            />) : (<PrivateRoute
              exact
              path="/ar/settings/:organizationId"
              component={CBAARSettings}
            />)}

            {!window.whitelabel ? (<PrivateRoute
              exact
              path="/ar/view/:organizationId/:contactId"
              component={ARView}
            />) : (<PrivateRoute
              exact
              path="/ar/view/:organizationId/:contactId"
              component={CBAARView}
            />)}

            <PrivateRoute
              exact
              path="/ar/affiliate/dashboard"
              component={ARAffiliate}
            />
            <PrivateRoute
              exact
              path="/ar/affiliate/settings"
              component={ARAffiliateSetting}
            />
            <PrivateRoute
              exact
              path="/ar/affiliate/demos"
              component={ARAffiliateDemoAccounts}
            />

            {window.whitelabel ? <PrivateRoute
              exact
              path="/wl/settings"
              component={WhitelabelSettings}
            /> : null}

            <Route path="/admin-login" component={AdminLogin} />
          </Switch>
        </Router>
      </WhitelabelProvider>
    </React.Fragment>
  );
};

export default AllRoutes;
